import React from "react";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";

/**
 * Reusable confirmation dialog wrapping shadcn AlertDialog.
 * Replaces native window.confirm() for destructive actions.
 *
 * Usage:
 *   const [pending, setPending] = useState(null);
 *   <ConfirmDialog
 *     open={!!pending}
 *     title="Delete this contract?"
 *     description="This permanently removes the contract and all its analyses."
 *     actionLabel="Delete"
 *     destructive
 *     testId="delete-contract-dialog"
 *     onConfirm={() => { doDelete(pending); setPending(null); }}
 *     onOpenChange={(v) => { if (!v) setPending(null); }}
 *   />
 */
export default function ConfirmDialog({
  open,
  onOpenChange,
  title,
  description,
  actionLabel = "Confirm",
  cancelLabel = "Cancel",
  destructive = false,
  onConfirm,
  testId = "confirm-dialog",
}) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent data-testid={testId}>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          {description && <AlertDialogDescription>{description}</AlertDialogDescription>}
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid={`${testId}-cancel`}>{cancelLabel}</AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            data-testid={`${testId}-confirm`}
            className={destructive ? "bg-rose-600 text-white hover:bg-rose-700" : ""}
          >
            {actionLabel}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
